<div class="modal-header">
  <h4 class="modal-title">Assign Approvers</h4>
</div>
<div class="modal-body" cdkScrollable>
  <section>
    @if (errorMsg !== '') {
      <p id="error-msg">Error:&nbsp;{{errorMsg}}</p>
    }
  </section>
  <form [formGroup]="approverForm">
    @for (item of getControls(); track item; let i = $index) {
      <div formArrayName="items">
        <div [formGroupName]="i">
          <section class="modal-section1">
            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
              <label for="name" class="Fields-label icon-label">Name (Email ID)</label>
              <div class="input-img">
                <input type="text" #autoCompleteInput placeholder="Enter Location" [matAutocomplete]="auto"
                  class="Fields-input form-control search-name" formControlName="approverName"
                  (focus)="searchApproversList = [];searchApprovers(item,'approverName','approverUid','approver','focus')"
                  (input)="searchApprovers(item,'approverName','approverUid','approver')"
                  (ngModelChange)="showNoResults = true">
                <span class="input-group-btn ">
                  <img class="user-img" src="/icons/{{baseSiteId}}/user.svg" alt="User">
                </span>
              </div>
              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="updateMySelection($event,item,'approverName','approverUid')">
                @if (!searchApproversList.length && showNoResults) {
                  <mat-option disabled class="noOptionData">
                    <span class="label">No result found. Try different keyword</span>
                  </mat-option>
                }
                @for (approver of searchApproversList; track approver) {
                  <mat-option [OptionValue]="approver"
                    [value]="approver.nameEmail">
                    {{approver.nameEmail}}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (item.controls.approverName.touched && item.controls.approverName.errors) {
                <section
                  class="invalid-error">
                  @if (item.controls.approverName.errors.required) {
                    <section>
                      Please select a customer
                    </section>
                  }
                </section>
              }
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
              <label for="phoneNumber" class="Fields-label icon-label">Phone Number</label>
              <input id="phoneNumber" name="phoneNumber" type="tel" [appMobMask]="'phone'" class="Fields-input"
                placeholder="xxx-xxx-xxxx" formControlName="approverPhoneNumber" maxlength="12">
              @if (item.controls.approverPhoneNumber.touched && item.controls.approverPhoneNumber.errors) {
                <section
                  class="invalid-error">
                  @if (item.controls.approverPhoneNumber.errors.required || item.controls.approverPhoneNumber.errors?.pattern) {
                    <section
                      >
                      Please enter a valid phone number
                    </section>
                  }
                </section>
              }
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
              <label for="phoneNumber" class="Fields-label icon-label">$ Threshold</label>
              <input id="phoneNumber" name="phoneNumber" type="text" placeholder="$xxxxx" class="Fields-input threshold"
                formControlName="threshold" (input)="allowOnlyNumber(item,'threshold')">
              @if (item.controls.threshold.touched && item.controls.threshold.errors) {
                <section class="invalid-error">
                  @if (item.controls.threshold.errors.required) {
                    <section>
                      This field is required
                    </section>
                  }
                </section>
              }
            </div>
          </section>
          <section class="modal-section2">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <div class="firstLevel-acc">
                    <label class="fs-14 light-color payment">
                      Delegate 1 <span>(Optional)</span>
                    </label>
                    <span class="accMinusIcon" [hidden]="!getExpandedItems(item,'delegate1Active')"
                      (click)="toggleAccordion(item, 'delegate1Active')">
                      <img src="/icons/{{baseSiteId}}/minus-green.png" alt="minus">
                    </span>
                    <span class="accPlusIcon" [hidden]="getExpandedItems(item,'delegate1Active')"
                      (click)="toggleAccordion(item,'delegate1Active')">
                      <img src="/icons/{{baseSiteId}}/plus-green.png" alt="plus">
                    </span>
                  </div>
                </div>
                <div class="grey-line" [hidden]="getExpandedItems(item,'delegate1Active')"></div>
                <div id="pdp-list2" class="panel-collapse" [hidden]="!getExpandedItems(item,'delegate1Active')">
                  <div class="panel-body">
                    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                      <label for="name" class="Fields-label icon-label">Name (Email ID)</label>
                      <div class="input-img">
                        <input id="name" name="name" #autoCompleteInput1 type="text" class="Fields-input search-name"
                          placeholder="" [matAutocomplete]="auto1" formControlName="delegate1Name"
                          (focus)="searchApproversList = [];searchApprovers(item,'delegate1Name','delegate1Uid','delegate','focus')"
                          (input)="searchApprovers(item,'delegate1Name','delegate1Uid','delegate')">
                        <span class="input-group-btn ">
                          <img class="user-img" src="/icons/{{baseSiteId}}/user.svg" alt="User">
                        </span>
                      </div>
                      <mat-autocomplete #auto1="matAutocomplete"
                        (optionSelected)="updateMySelection($event,item,'delegate1Name','delegate1Uid')">
                        @if (!searchApproversList.length) {
                          <mat-option disabled class="noOptionData">
                            <span class="label">No result found. Try different keyword</span>
                          </mat-option>
                        }
                        @for (approver of searchApproversList; track approver) {
                          <mat-option [OptionValue]="approver"
                            [value]="approver.nameEmail">
                            {{approver.nameEmail}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                      <label for="phoneNumber" class="Fields-label icon-label">Phone Number</label>
                      <input id="phoneNumber" name="phoneNumber" type="tel" [appMobMask]="'phone'" class="Fields-input"
                        placeholder="xxx-xxx-xxxx" formControlName="delegate1PhoneNumber" maxlength="12">
                      @if (item.controls.delegate1PhoneNumber.errors) {
                        <section class="invalid-error">
                          @if (item.controls.delegate1PhoneNumber.errors?.pattern) {
                            <section>
                              Please enter a valid phone number
                            </section>
                          }
                        </section>
                      }
                    </div>
                  </div>
                  <div class="grey-line" [hidden]="getExpandedItems(item,'delegate1Active')"></div>
                </div>
              </div>
            </div>
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <div class="firstLevel-acc">
                    <label class="fs-14 light-color payment">
                      Delegate 2 <span>(Optional)</span>
                    </label>
                    <span class="accMinusIcon" [hidden]="!getExpandedItems(item, 'delegate2Active')"
                      (click)="toggleAccordion(item, 'delegate2Active')">
                      <img src="/icons/{{baseSiteId}}/minus-green.png" alt="minus">
                    </span>
                    <span class="accPlusIcon" [hidden]="getExpandedItems(item, 'delegate2Active')"
                      (click)="toggleAccordion(item, 'delegate2Active')">
                      <img src="/icons/{{baseSiteId}}/plus-green.png" alt="plus">
                    </span>
                  </div>
                </div>
                <div class="grey-line" [hidden]="getExpandedItems(item, 'delegate2Active')"></div>
                <div id="pdp-list2" class="panel-collapse" [hidden]="!getExpandedItems(item, 'delegate2Active')">
                  <div class="panel-body">
                    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                      <label for="name" class="Fields-label icon-label">Name (Email ID)</label>
                      <div class="input-img">
                        <input id="name" name="name" #autoCompleteInput2 type="text" class="Fields-input search-name"
                          placeholder="" formControlName="delegate2Name" [matAutocomplete]="auto2"
                          (focus)="searchApproversList = [];searchApprovers(item,'delegate2Name','delegate2Uid','delegate','focus')"
                          (input)="searchApprovers(item,'delegate2Name','delegate2Uid','delegate')">
                        <span class="input-group-btn ">
                          <img class="user-img" src="/icons/{{baseSiteId}}/user.svg" alt="User">
                        </span>
                      </div>
                      <mat-autocomplete #auto2="matAutocomplete"
                        (optionSelected)="updateMySelection($event,item,'delegate2Name','delegate2Uid')">
                        @if (!searchApproversList.length) {
                          <mat-option disabled class="noOptionData">
                            <span class="label">No result found. Try different keyword</span>
                          </mat-option>
                        }
                        @for (approver of searchApproversList; track approver) {
                          <mat-option [OptionValue]="approver"
                            [value]="approver.nameEmail">
                            {{approver.nameEmail}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                      <label for="phoneNumber" class="Fields-label icon-label">Phone Number</label>
                      <input id="phoneNumber" name="phoneNumber" type="tel" [appMobMask]="'phone'" class="Fields-input"
                        placeholder="xxx-xxx-xxxx" formControlName="delegate2PhoneNumber" maxlength="12">
                      @if (item.controls.delegate2PhoneNumber.errors) {
                        <section class="invalid-error">
                          @if (item.controls.delegate2PhoneNumber.errors?.pattern) {
                            <section>
                              Please enter a valid phone number
                            </section>
                          }
                        </section>
                      }
                    </div>
                  </div>
                  <div class="grey-line" [hidden]="getExpandedItems(item, 'delegate2Active')"></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    }
  </form>
  @if (type !== 'edit') {
    <button type="button" id="add-another" class="btn-secondary" (click)="addApprovers()">
      Add another approver
    </button>
  }
</div>
<div class="modal-footer">
  <div class="change-request-btngrps">
    <button type="submit" class="btn-primary" data-di-id="#addApprover"
      [disabled]="!submitted ? !approverForm.valid: 'true'" (click)="addUpdateApprovers()">
      Assign approver(s)
    </button>
    <button type="button" class="btn-secondary" data-dismiss="modal" (click)="cancelPopup()">
      Cancel
    </button>
  </div>
</div>
